<template>
    <single-select :value="usedPreset" :options="presets" @input="onPresetSelected"
                   :getOptionLabel="localizeOption" :placeholder="$t('presetbar.label_placeholder')"/>
</template>
<script>
    import Vue from 'vue';
    import {Component, Model} from 'vue-property-decorator';
    import SingleSelect from '../../general/SingleSelect';
    import moment from 'moment';

    @Component({
        components: {
            SingleSelect,
        }
    })
    export default class DaterangePresets extends Vue {
        @Model({
            type: Object,
            default: () => ({
                begin: null,
                end: null,
            })
        })
        daterange;

        get usedPreset() {
            // This is put into a getter which will become a reactive property so updates are automatically triggered
            // When daterange changes then check if the selected value in the dropdown should be changed
            const start = moment(this.daterange.start);
            const end = moment(this.daterange.end);
            return this.presets
            // Map into object that holds original preset and the start and end moments
                .map(preset => ({preset, ...preset.to()}))
                // Filter out mismatched start dates
                .filter(data => start.isSame(data.start, 'day'))
                // Filter out mismatched end dates
                .filter(data => end.isSame(data.end, 'day'))
                // Map back to original presets, select the first result. If no result then return null instead of undefined.
                .map(data => data.preset)[0] || null;
        }

        presets = [
            {label: 'presetbar.label_days7', to: () => this.linkDays(7)},
            {label: 'presetbar.label_days30', to: () => this.linkDays(30)},
            {label: 'presetbar.label_thismonth', to: () => this.linkThisMonth()},
            {label: 'presetbar.label_thisyear', to: () => this.linkThisYear()},
            {label: 'presetbar.label_months1', to: () => this.linkMonths(1)},
            {label: 'presetbar.label_months3', to: () => this.linkMonths(3)},
            {label: 'presetbar.label_months6', to: () => this.linkMonths(6)},
        ];

        onPresetSelected(preset) {
            const {start, end} = preset.to();
            this.setDateRange(start, end);
        }

        localizeOption(option) {
            return this.$t(option.label);
        }

        linkDays(days) {
            const end = moment();
            // One day is added because the range is inclusive, meaning a difference of 6 days results in a range of 7 days.
            const start = moment(end).subtract(days - 1, 'days');
            return {start, end};
        }

        linkMonths(months) {
            const end = moment();
            const start = moment(end).subtract(months, 'months');
            return {start, end};
        }

        linkThisMonth() {
            const end = moment().endOf('month');
            const start = moment(end).startOf('month');
            return {start, end};
        }

        linkThisYear() {
            const end = moment().endOf('year');
            const start = moment(end).startOf('year');
            return {start, end};
        }

        /**
         * Updates the daterange to the specified momentjs dates
         * @param {Moment} start
         * @param {Moment} end
         */
        setDateRange(start, end) {
            this.daterange.start = start;
            this.daterange.end = end;
            this.daterange.highlight = null;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/dashboard/presetbar/DaterangePresets.vue